import { Autocomplete, TextField } from '@mui/material';

const AnalyticsDropdownFilter = ({ filterOption, filterMenu, keyParam, onFieldChange, placeHolder, disabled }) => {
    const config = filterMenu[keyParam];
    const { options, valueKey, labelKey, multiple, renderOption, disableClearable, loading, noOptionsText } = config;

    const getMultiValue = () => {
        if (!options?.length || !filterOption[keyParam]) return [];
        const selectedValues = filterOption[keyParam].toString().split(',');
        return options.filter((item) => selectedValues.includes(item[valueKey].toString()));
    };

    const getSingleValue = () => {
        if (!options?.length || !filterOption[keyParam]) return null;
        return options.find((item) => item[valueKey] === filterOption[keyParam]) || null;
    };

    return (
        <Autocomplete
            options={options || []}
            getOptionLabel={(option) => option?.[labelKey] ?? ''}
            id={keyParam}
            multiple={!!multiple}
            disabled={!!disabled}
            disableClearable={!!disableClearable}
            loading={!!loading}
            noOptionsText={noOptionsText}
            value={multiple ? getMultiValue() : getSingleValue()}
            onChange={(_, value) => {
                if (multiple) {
                    onFieldChange(keyParam, value.map((item) => item[valueKey]).join(',').toString());
                } else {
                    onFieldChange(keyParam, value ? value[valueKey] : null);
                }
            }}
            isOptionEqualToValue={(option, value) => option?.[valueKey] === value?.[valueKey]}
            {...(renderOption && { renderOption })}
            size='small'
            sx={{ mt: 2, '& .MuiOutlinedInput-root': { borderRadius: '5px' } }}
            renderInput={(params) => (
                <TextField
                    slotProps={{ inputLabel: { shrink: true } }}
                    {...params}
                    label={config.title}
                    fullWidth
                    placeholder={placeHolder}
                    variant='outlined'
                />
            )}
        />
    );
};

export default AnalyticsDropdownFilter;
